import { cn } from '../../../lib/utils'
import { InputHTMLAttributes, forwardRef, ReactNode } from 'react'

interface GlassInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  icon?: ReactNode
}

export const GlassInput = forwardRef<HTMLInputElement, GlassInputProps>(
  ({ label, error, icon, className, id, ...props }, ref) => {
    const inputId = id ?? (label ? `input-${label.toLowerCase().replace(/\s+/g, '-')}` : undefined)
    return (
      <div className="flex flex-col gap-1.5">
        {label && (
          <label htmlFor={inputId} className="text-sm font-medium text-white/70">{label}</label>
        )}
        <div className="relative">
          {icon && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40">
              {icon}
            </span>
          )}
          <input
            ref={ref}
            id={inputId}
            className={cn(
              'w-full bg-white/[0.05] border border-white/10 rounded-xl text-white placeholder-white/30',
              'focus:outline-none focus:border-sky-500/60 focus:bg-white/[0.08] transition-all duration-200',
              'px-4 py-3 text-sm',
              icon && 'pl-10',
              error && 'border-red-500/50 focus:border-red-500/70',
              className
            )}
            {...props}
          />
        </div>
        {error && <p className="text-xs text-red-400">{error}</p>}
      </div>
    )
  }
)
GlassInput.displayName = 'GlassInput'
